import { render } from "./HeroExhibition.vue?vue&type=template&id=52847c80&scoped=true&ts=true"
import script from "./HeroExhibition.ts?vue&type=script&lang=ts"
export * from "./HeroExhibition.ts?vue&type=script&lang=ts"

import "./HeroExhibition.scss?vue&type=style&index=0&id=52847c80&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52847c80"]])

export default __exports__